import { render, staticRenderFns } from "./AddressesCards.vue?vue&type=template&id=fd5e9604&scoped=true&"
import script from "./AddressesCards.vue?vue&type=script&lang=js&"
export * from "./AddressesCards.vue?vue&type=script&lang=js&"
import style0 from "./AddressesCards.vue?vue&type=style&index=0&id=fd5e9604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5e9604",
  null
  
)

export default component.exports